// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ECharts from "echarts";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import router from "./router";
import "./permission"; // 路由守卫

// // 导入tailwind
import "@/assets/tailwind.css";

// 导入全局样式
import "@/assets/styles/global.css";

// 导入fontawesome
import "@fortawesome/fontawesome-free/css/all.min.css";

// 导入vuex
import store from "./store";

// import { debounce } from "@/utils/debounce.js";
// Vue.prototype.$debounce = debounce;

// 引入打印插件
import Print from "vue-print-nb";

// 引入 MyEditor 组件
import MyEditor from "@/components/MyEditor/index.vue";
// 全局注册 MyEditor 组件
Vue.component("MyEditor", MyEditor);

// 引入 MyModal 组件
import MyModal from "@/components/MyModal/MyModal.vue";
// 全局注册 MyModal 组件
Vue.component("MyModal", MyModal);

// 注册插件
Vue.use(Print);

Vue.config.productionTip = false;
Vue.use(ElementUI);
// Vue.component('v-chart', ECharts)
Vue.prototype.$echarts = ECharts;

import "./plugins/element.js";

import "./utils/websocket.js"; // 引入 WebSocket 工具

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js